// This file was automatically generated. Do not edit manually.

export enum Metrics {
    depositLedgerUsBalance = 'depositLedgerUsBalance',
    guestLedgerUsBalance = 'guestLedgerUsBalance',
    guestLedgerUsCharges = 'guestLedgerUsCharges',
    guestLedgerUsPaid = 'guestLedgerUsPaid',
    lastProcessedTSEnterprise = 'lastProcessedTSEnterprise',
    loadSuccessRate = 'loadSuccessRate',
    maximumTimeSinceDataUpdatedPerProperty = 'maximumTimeSinceDataUpdatedPerProperty',
    mmrAverageDailyRateGross = 'mmrAverageDailyRateGross',
    mmrAverageDailyRateNet = 'mmrAverageDailyRateNet',
    mmrAverageDailyRateTax = 'mmrAverageDailyRateTax',
    mmrAverageNightlyRateGross = 'mmrAverageNightlyRateGross',
    mmrAverageNightlyRateNet = 'mmrAverageNightlyRateNet',
    mmrAverageNightlyRateTax = 'mmrAverageNightlyRateTax',
    mmrNumberOfAvailableResources = 'mmrNumberOfAvailableResources',
    mmrNumberOfAvailableRooms = 'mmrNumberOfAvailableRooms',
    mmrNumberOfCustomers = 'mmrNumberOfCustomers',
    mmrNumberOfOccupiedResourcesFromBookableServices = 'mmrNumberOfOccupiedResourcesFromBookableServices',
    mmrNumberOfOccupiedResourcesFromOtherServices = 'mmrNumberOfOccupiedResourcesFromOtherServices',
    mmrNumberOfOccupiedResourcesFromOutOfOrder = 'mmrNumberOfOccupiedResourcesFromOutOfOrder',
    mmrNumberOfOccupiedRoomsFromBookableServices = 'mmrNumberOfOccupiedRoomsFromBookableServices',
    mmrNumberOfOccupiedRoomsFromOutOfOrder = 'mmrNumberOfOccupiedRoomsFromOutOfOrder',
    mmrOccupancy = 'mmrOccupancy',
    mmrOccupancyRoom = 'mmrOccupancyRoom',
    mmrRevenueAdditionalGross = 'mmrRevenueAdditionalGross',
    mmrRevenueAdditionalNet = 'mmrRevenueAdditionalNet',
    mmrRevenueAdditionalRoomGross = 'mmrRevenueAdditionalRoomGross',
    mmrRevenueAdditionalRoomNet = 'mmrRevenueAdditionalRoomNet',
    mmrRevenueAdditionalRoomTax = 'mmrRevenueAdditionalRoomTax',
    mmrRevenueAdditionalTax = 'mmrRevenueAdditionalTax',
    mmrRevenueIndirectServiceGross = 'mmrRevenueIndirectServiceGross',
    mmrRevenueIndirectServiceNet = 'mmrRevenueIndirectServiceNet',
    mmrRevenueOutletGross = 'mmrRevenueOutletGross',
    mmrRevenueOutletNet = 'mmrRevenueOutletNet',
    mmrRevenueOutletTax = 'mmrRevenueOutletTax',
    mmrRevenuePerAvailableRoomGross = 'mmrRevenuePerAvailableRoomGross',
    mmrRevenuePerAvailableRoomNet = 'mmrRevenuePerAvailableRoomNet',
    mmrRevenuePerAvailableRoomTax = 'mmrRevenuePerAvailableRoomTax',
    mmrRevenueProductGross = 'mmrRevenueProductGross',
    mmrRevenueProductNet = 'mmrRevenueProductNet',
    mmrRevenueProductRoomGross = 'mmrRevenueProductRoomGross',
    mmrRevenueProductRoomNet = 'mmrRevenueProductRoomNet',
    mmrRevenueProductRoomTax = 'mmrRevenueProductRoomTax',
    mmrRevenueProductTax = 'mmrRevenueProductTax',
    mmrRevenueServiceGross = 'mmrRevenueServiceGross',
    mmrRevenueServiceNet = 'mmrRevenueServiceNet',
    mmrRevenueServicePerAvailableResourceGross = 'mmrRevenueServicePerAvailableResourceGross',
    mmrRevenueServicePerAvailableResourceNet = 'mmrRevenueServicePerAvailableResourceNet',
    mmrRevenueServicePerAvailableResourceTax = 'mmrRevenueServicePerAvailableResourceTax',
    mmrRevenueServiceRoomGross = 'mmrRevenueServiceRoomGross',
    mmrRevenueServiceRoomNet = 'mmrRevenueServiceRoomNet',
    mmrRevenueServiceRoomTax = 'mmrRevenueServiceRoomTax',
    mmrRevenueServiceTax = 'mmrRevenueServiceTax',
    mmrRevenueTotalExcludingRoomGross = 'mmrRevenueTotalExcludingRoomGross',
    mmrRevenueTotalExcludingRoomNet = 'mmrRevenueTotalExcludingRoomNet',
    mmrRevenueTotalExcludingRoomTax = 'mmrRevenueTotalExcludingRoomTax',
    mmrRevenueTotalGross = 'mmrRevenueTotalGross',
    mmrRevenueTotalNet = 'mmrRevenueTotalNet',
    mmrRevenueTotalServiceGross = 'mmrRevenueTotalServiceGross',
    mmrRevenueTotalServiceNet = 'mmrRevenueTotalServiceNet',
    mmrRevenueTotalServiceTax = 'mmrRevenueTotalServiceTax',
    mmrRevenueTotalTax = 'mmrRevenueTotalTax',
}

export const metrics = {
    depositLedgerUsBalance: {
        id: 'depositLedgerUsBalance',
        title: 'Deposit Ledger US - Balance',
        description: '',
    },
    guestLedgerUsBalance: {
        id: 'guestLedgerUsBalance',
        title: 'Guest Ledger US - Balance',
        description: '',
    },
    guestLedgerUsCharges: {
        id: 'guestLedgerUsCharges',
        title: 'Guest Ledger US - Charges',
        description: '',
    },
    guestLedgerUsPaid: {
        id: 'guestLedgerUsPaid',
        title: 'Guest Ledger US - Paid',
        description: '',
    },
    lastProcessedTSEnterprise: {
        id: 'lastProcessedTSEnterprise',
        title: 'Last processed TS - Enterprise',
        description: '',
    },
    loadSuccessRate: {
        id: 'loadSuccessRate',
        title: 'Load success rate',
        description: '',
    },
    maximumTimeSinceDataUpdatedPerProperty: {
        id: 'maximumTimeSinceDataUpdatedPerProperty',
        title: 'Maximum time passed since data updated per property',
        description: 'Owner: Analytics Team, Documentation: https://mews.atlassian.net/wiki/x/PABjCg',
    },
    mmrAverageDailyRateGross: {
        id: 'mmrAverageDailyRateGross',
        title: 'Average daily rate in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrAverageDailyRateNet: {
        id: 'mmrAverageDailyRateNet',
        title: 'Average daily rate in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrAverageDailyRateTax: {
        id: 'mmrAverageDailyRateTax',
        title: 'Average daily rate in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrAverageNightlyRateGross: {
        id: 'mmrAverageNightlyRateGross',
        title: 'Average nightly rate in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrAverageNightlyRateNet: {
        id: 'mmrAverageNightlyRateNet',
        title: 'Average nightly rate in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrAverageNightlyRateTax: {
        id: 'mmrAverageNightlyRateTax',
        title: 'Average nightly rate in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfAvailableResources: {
        id: 'mmrNumberOfAvailableResources',
        title: 'Number of available resources',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfAvailableRooms: {
        id: 'mmrNumberOfAvailableRooms',
        title: 'Number of available rooms',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfCustomers: {
        id: 'mmrNumberOfCustomers',
        title: 'Number of customers',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfOccupiedResourcesFromBookableServices: {
        id: 'mmrNumberOfOccupiedResourcesFromBookableServices',
        title: 'Number of occupied resources from the bookable services',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfOccupiedResourcesFromOtherServices: {
        id: 'mmrNumberOfOccupiedResourcesFromOtherServices',
        title: 'Number of occupied resources from other services',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfOccupiedResourcesFromOutOfOrder: {
        id: 'mmrNumberOfOccupiedResourcesFromOutOfOrder',
        title: 'Number of occupied resources from resources that are out of order',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfOccupiedRoomsFromBookableServices: {
        id: 'mmrNumberOfOccupiedRoomsFromBookableServices',
        title: 'Number of occupied rooms from the bookable services',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrNumberOfOccupiedRoomsFromOutOfOrder: {
        id: 'mmrNumberOfOccupiedRoomsFromOutOfOrder',
        title: 'Number of occupied rooms from resources that are out of order',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrOccupancy: {
        id: 'mmrOccupancy',
        title: 'Occupancy',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrOccupancyRoom: {
        id: 'mmrOccupancyRoom',
        title: 'Occupancy from the space type Room',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueAdditionalGross: {
        id: 'mmrRevenueAdditionalGross',
        title: 'Revenue of the Additional revenue type in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueAdditionalNet: {
        id: 'mmrRevenueAdditionalNet',
        title: 'Revenue of the Additional revenue type in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueAdditionalRoomGross: {
        id: 'mmrRevenueAdditionalRoomGross',
        title: 'Revenue of the Additional revenue type from the space type Room in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueAdditionalRoomNet: {
        id: 'mmrRevenueAdditionalRoomNet',
        title: 'Revenue of the Additional revenue type from the space type Room in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueAdditionalRoomTax: {
        id: 'mmrRevenueAdditionalRoomTax',
        title: 'Revenue of the Additional revenue type from the space type Room in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueAdditionalTax: {
        id: 'mmrRevenueAdditionalTax',
        title: 'Revenue of the Additional revenue type in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueIndirectServiceGross: {
        id: 'mmrRevenueIndirectServiceGross',
        title: 'Revenue of the Service revenue type from indirectly assigned resources (with a parent resource) in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueIndirectServiceNet: {
        id: 'mmrRevenueIndirectServiceNet',
        title: 'Revenue of the Service revenue type from indirectly assigned resources (with a parent resource) in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueOutletGross: {
        id: 'mmrRevenueOutletGross',
        title: 'Revenue from outlet items in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueOutletNet: {
        id: 'mmrRevenueOutletNet',
        title: 'Revenue from outlet items in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueOutletTax: {
        id: 'mmrRevenueOutletTax',
        title: 'Revenue from outlet items in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenuePerAvailableRoomGross: {
        id: 'mmrRevenuePerAvailableRoomGross',
        title: 'Revenue per available room in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenuePerAvailableRoomNet: {
        id: 'mmrRevenuePerAvailableRoomNet',
        title: 'Revenue per available room in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenuePerAvailableRoomTax: {
        id: 'mmrRevenuePerAvailableRoomTax',
        title: 'Revenue per available room in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueProductGross: {
        id: 'mmrRevenueProductGross',
        title: 'Revenue of the Product revenue type in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueProductNet: {
        id: 'mmrRevenueProductNet',
        title: 'Revenue of the Product revenue type in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueProductRoomGross: {
        id: 'mmrRevenueProductRoomGross',
        title: 'Revenue of the Product revenue type from the space type Room in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueProductRoomNet: {
        id: 'mmrRevenueProductRoomNet',
        title: 'Revenue of the Product revenue type from the space type Room in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueProductRoomTax: {
        id: 'mmrRevenueProductRoomTax',
        title: 'Revenue of the Product revenue type from the space type Room in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueProductTax: {
        id: 'mmrRevenueProductTax',
        title: 'Revenue of the Product revenue type in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServiceGross: {
        id: 'mmrRevenueServiceGross',
        title: 'Revenue of the Service revenue type in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServiceNet: {
        id: 'mmrRevenueServiceNet',
        title: 'Revenue of the Service revenue type in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServicePerAvailableResourceGross: {
        id: 'mmrRevenueServicePerAvailableResourceGross',
        title: 'Revenue of the Service revenue type per available resource in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServicePerAvailableResourceNet: {
        id: 'mmrRevenueServicePerAvailableResourceNet',
        title: 'Revenue of the Service revenue type per available resource in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServicePerAvailableResourceTax: {
        id: 'mmrRevenueServicePerAvailableResourceTax',
        title: 'Revenue of the Service revenue type per available resource in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServiceRoomGross: {
        id: 'mmrRevenueServiceRoomGross',
        title: 'Revenue of the Service revenue type from the space type Room in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServiceRoomNet: {
        id: 'mmrRevenueServiceRoomNet',
        title: 'Revenue of the Service revenue type from the space type Room in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServiceRoomTax: {
        id: 'mmrRevenueServiceRoomTax',
        title: 'Revenue of the Service revenue type from the space type Room in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueServiceTax: {
        id: 'mmrRevenueServiceTax',
        title: 'Revenue of the Service revenue type in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalExcludingRoomGross: {
        id: 'mmrRevenueTotalExcludingRoomGross',
        title: 'Revenue of all revenue types excluding the space type Room in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalExcludingRoomNet: {
        id: 'mmrRevenueTotalExcludingRoomNet',
        title: 'Revenue of all revenue types excluding the space type Room in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalExcludingRoomTax: {
        id: 'mmrRevenueTotalExcludingRoomTax',
        title: 'Revenue of all revenue types excluding the space type Room in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalGross: {
        id: 'mmrRevenueTotalGross',
        title: 'Revenue of the all revenue types in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalNet: {
        id: 'mmrRevenueTotalNet',
        title: 'Revenue of the all revenue types in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalServiceGross: {
        id: 'mmrRevenueTotalServiceGross',
        title: 'Revenue of the Service revenue type from direct and indirect assigned resources in gross',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalServiceNet: {
        id: 'mmrRevenueTotalServiceNet',
        title: 'Revenue of the Service revenue type from direct and indirect assigned resources in net',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalServiceTax: {
        id: 'mmrRevenueTotalServiceTax',
        title: 'Revenue of the Service revenue type from direct and indirect assigned resources in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
    mmrRevenueTotalTax: {
        id: 'mmrRevenueTotalTax',
        title: 'Revenue of the all revenue types in tax',
        description: 'Owner: Analytics Team, Product: Mews Manager Report',
    },
};
